<template>
  <div>
    <Header>Авторизация</Header>
    <div class="container">
      <div class="row wrapper">
        <!-- VISIT FORM -->
        <form method="GET" action="#" class="visit col-xl-12 col-12" v-on:submit="stopSubmit($event)">
          <div class="visit-form">
            <section class="visit-form-wrapper wrapper-white bottom-border">
              <div class="input-wrapper wrapper-name">
                <input type="text"
                  :value="username"
                  v-on:keypress="changeInput($event)"
                  name="name"
                  placeholder="Имя"
                  required>
              </div>
              <div class="input-wrapper wrapper-phone">
                <vue-mask
                    class="phone-mask"
                    mask="+380 99 999 99 99"
                    :value="userphone ? userphone : (phone ? phone : '+380')"
                    name="phone"
                    required="required"
                    placeholder="+380"
                    :raw="false">
                </vue-mask>
              </div>
            </section>
            <section class="col-xl-12 col-12 wrapper-white">
              <span class="visit-form--information">
                Для записи к специалисту введите свое имя и номер телефона
              </span>
              <button class="btn button-gray" v-on:click="moveToConfirm($event)">{{ buttonText }}</button>
            </section>
          </div>
        </form>
      </div>
      <!-- POPUP -->
      <Popup/>
    </div>
  </div>
</template>

<style>
  .button-blue {
      padding: 1rem 0px;
      width: 100%;
      text-align: center;
      background: #2F80ED;
      backdrop-filter: blur(81.6395px);
      border: none;
      border-radius: 36px;
      color: #fff;
      margin-bottom: 1rem;
    }
  .button-blue:active {
    background: #ff9500;
    color: #fff;
  }
  .button-gray {
    padding: 1rem 0px;
    width: 100%;
    text-align: center;
    background: #C4C4C4;
    backdrop-filter: blur(81.6395px);
    border: none;
    border-radius: 36px;
    color: #fff;
    margin-bottom: 1rem;
  }

  .phone-mask::placeholder {
    color: #2F80ED;
  }
</style>

<script>
import Popup from '../components/popup.vue';
import vueMask from 'vue-jquery-mask';
import $ from 'jquery';
import Header from '../components/header.vue';
import axios from 'axios';

export default {
  name: 'Form',
  data() {
      let buttonText = 'Создать запись';
      if (window.APP_MODE === window.MODE_BOOKING) {
        buttonText = 'Продолжить';
      }
      return {
        buttonText: buttonText,
        userphoneValue: '',
        usernameValue: '',
        option: {

        },
        blockButton: false,
      };
  },
  metaInfo: {
      title: 'Авторизация',
      titleTemplate: '%s - Онлайн-запись MyClient',
      htmlAttrs: {
          lang: 'ru',
          amp: false
      }
  },
  mounted: function() {
    const vm = this;

    vm.showButtom();

    const changeValue = function(vm, event) {
      let el = $(event.target);
      let elName = el.attr('name');

      if(elName === 'name') {
        vm.usernameValue = el.val();
        vm.$store.dispatch('username', el.val());
      }

      if(elName === 'phone') {
        vm.userphoneValue = el.val();
        vm.$store.dispatch('userphone', el.val());
      }

      vm.showButtom();
    }

    $(document).on('change', '.visit input', function(event) {
      changeValue(vm, event);
    });

    $(document).on('keyup', '.visit input', function(event) {
      changeValue(vm, event);
    });

    $(document).on('keydown', '.visit input', function(event) {
      changeValue(vm, event);
    });

    $(document).on('keypress', '.visit input', function(event) {
      changeValue(vm, event);
    });

    $('[name="name"]').change();
    $('[name="phone"]').change();

    let selectedCheck = false;
    const services = vm.services;
    if(window.professionalId) {
      for(let index in services) {
        let service = services[index];

        if(service) {
          selectedCheck = true;
        }
      }

      if(selectedCheck === false) {
        location.href = '/professional/' + window.professionalId;
        return;
      }
    }
  },
  beforeCreate: function() {
    document.body.className = 'form';
  },
  methods: {
      changeInput: function(event) {

      },
      moveToConfirm: function(event) {
        this.$store.dispatch('username', $('[name="name"]').val());
        this.$store.dispatch('userphone', $('[name="phone"]').val());

        if (!this.blockButton) {
          this.blockButton = true;

          if ($(event.target).hasClass('button-blue')) {
            axios.post('/api/sms', {
              phone: this.userphone ? this.userphone : this.userphoneValue,
            }).then((response) => {
              this.$router.push('/confirm_form');
              this.blockButton = false;
            });
          } else {
            this.blockButton = false;
          }
        }

      },
      stopSubmit: function(event) {
        event.preventDefault();
      },
      showButtom: function() {
        if(
          String(this.userphone).length >= 17 && this.username !== ''
          || String(this.userphoneValue).length >= 17 && this.usernameValue !== ''
        ) {
          localStorage.setItem('phone', this.userphone ? this.userphone : this.userphoneValue);
          $('.btn').removeClass('button-gray');
          $('.btn').addClass('button-blue');
        } else {
          $('.btn').removeClass('button-blue');
          $('.btn').addClass('button-gray');
        }
      }
  },
  components: {
    vueMask,
    Header,
    Popup
  },
  computed: {
    username() {
      return this.$store.getters.username;
    },
    services() {
      return this.$store.getters.services;
    },
    userphone() {
      return this.$store.getters.userphone;
    },
    phone() {
      return this.$store.getters.phone;
    },
    professionalId() {
      return this.$store.getters.professionalId;
    },
    bookingId() {
      return this.$store.getters.bookingId;
    },
    search() {
      return this.$store.getters.search;
    },
    professionalServicesList() {
      return this.$store.getters.professionalServicesList;
    }
  },
};
</script>
